import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { FEATURE } from 'constants/feature'
import { SESSION_KEY } from 'constants/index'
import { usePermission } from 'hooks/use-permission'

interface PrivateRouteProps {
  children: ReactNode
  feature?: FEATURE
  /** When true, requires CRUD on `feature` instead of view-only access. */
  requireCRUD?: boolean
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, feature, requireCRUD }) => {
  const token = sessionStorage.getItem(SESSION_KEY.TOKEN)
  const { canView, canCRUD, userRole } = usePermission()

  if (!token) return <Navigate to="/login" />
  if (!userRole) return <Navigate to="/no-permission" />

  if (feature !== undefined) {
    const featureAllowed = requireCRUD ? canCRUD(feature) : canView(feature)
    if (!featureAllowed) return <Navigate to="/no-permission" />
  }

  return <>{children}</>
}

export default PrivateRoute
